<template>
  <div class="">
    <BmiForm
      :form-data="additionalDetails.bmi"
      :prefix="'member' + memberIndex"
    />
    <SupplementaryQuestionForm
      :additional-details="additionalDetails"
      :prefix="'family-member' + memberIndex"
    />
  </div>
</template>

<script>
import BmiForm from '../Form/BmiForm.vue'
import SupplementaryQuestionForm from '../Form/SupplementaryQuestionForm.vue'
export default {
    name: 'PolicyHolderByFamily',
    components: {
        BmiForm,
        SupplementaryQuestionForm,
    },
    props: {
        familyData: {
            type: Object,
            required: true
        },
        memberIndex: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            additionalDetails: this.familyData.additionalDetails,
            metricUnit: true, // false -> imperial
            isOpen: false,
        }
    },
    mounted() {},
    methods: {
        toggleForm() {
            this.isOpen = !this.isOpen
        },
    },
}
</script>
